<template>
	<div>
        <buttonlist @help="help" ref="SetBtn"></buttonlist>
		<el-tabs :tab-position="'top'" type="" style="margin-top: 5px">
            <el-tab-pane :label="$t('getapi[13078]')"> <!-- 更新出口相关数据 -->
                <el-row style=" margin: 0px auto 5px;background: white;padding: 10px 20px 5px;">
                    <el-col :span="12">                        
						<el-upload
								class="upload-demo"
								ref="upload"
								:action="uploadurl"
								:on-preview="handlePreview"
								:on-remove="handleRemove"
								:on-change="handleChange"
								:on-success="handleSuccess"
								:on-error="handleError"
								:file-list="fileList"
								:limit="1"
								accept=".xlsx"
						>
							<el-button slot="trigger" size="small" type="primary" :disabled="!btn.Import">{{$t('getapi[6422]')}}</el-button>
							
						</el-upload>
                    </el-col>
                    <el-col :span="12" align="right">
						<el-button  size="small" type="warning"  @click="monthCheck" >{{$t('getapi[13086]')}}</el-button>
						<el-button type="primary" size="small" @click="deleteAll">{{$t('getapi[3886]')}}</el-button>
                        <el-button type="primary" size="small" @click="update">{{$t('getapi[370]')}}</el-button>
                    </el-col>
                </el-row>
                <vxe-table :data="datajson"
						show-overflow
						ref='CloseSoTable'
						size="mini" :loading="loading"  :height="tableHeight" stripe border resizable>
					<vxe-table-column type="checkbox" align="center" width="60"></vxe-table-column>
					<vxe-table-column  show-footer-overflow v-for="item in returnArray" 
						:key="item.Headen"
						:field="item.Headen"
						:title="item.Headcn"
						width="140px"
					>
					</vxe-table-column>
				</vxe-table>
            </el-tab-pane>
            <el-tab-pane :label="$t('getapi[13079]')"><!-- 导入系统外数据 -->
                <el-row style=" margin: 0px auto 5px;background: white;padding: 10px 20px 5px;">
                    <el-col :span="12">
                        <el-upload
                                class="upload-demo"
                                ref="upload"
                                :action="uploadurloutsys"
                                :on-preview="handlePreview"
                                :on-remove="handleRemove"
                                :on-change="handleChangeoutsys"
                                :on-success="handleSuccessoutsys"
                                :on-error="handleError"
                                :file-list="fileListOutSys"
                                :limit="1"
								accept=".xlsx"
                        >
                            <el-button slot="trigger" size="small" type="primary" >{{$t('getapi[6422]')}}
                            </el-button>
                        </el-upload>
                    </el-col>
                    <el-col :span="12" align="right">
						<el-button  size="small" type="warning"  @click="downloadTemplate" >{{$t('getapi[13086]')}}</el-button>
						<el-button type="primary" size="small"  @click="deleteAllOut">{{$t('getapi[3886]')}}</el-button>
                        <el-button @click="okbtnOutSys" size="small" type="primary" :loading="loading" >{{$t('getapi[370]')}}</el-button>
                    </el-col>
                </el-row>
                <!-- 表格 -->
                <vxe-table :data="datajsonoutsys"
						show-overflow
						ref='CloseTableOutSys'
						size="mini" :loading="loading"  :height="tableHeight" stripe border resizable>
					<vxe-table-column type="checkbox" align="center" width="60"></vxe-table-column>
					<vxe-table-column  show-footer-overflow v-for="item in returnArrayOutSys" 
						:key="item.Headen"
						:field="item.Headen"
						:title="item.Headcn"
						width="140px"
					>
					</vxe-table-column>
				</vxe-table>
            </el-tab-pane>
        </el-tabs>

		
		<el-dialog v-dialogDrag :title="$t('getapi[1273]')" :visible.sync="monthCheckVisible" width="30%" :close-on-click-modal="false">
			<table>
				<tr>
					<td style="width:60px">{{ $t("getapi[1974]") }}</td>
					<td style="width:150px;">
						<el-input v-model="year" type="text" size="mini"></el-input>
					</td>
					<td style="width:60px">{{ $t("getapi[1975]") }}</td>
					<td style="width:150px;">
						<el-select
								filterable
								v-model="month"
								multiple
								size="mini"
								style="margin-right: 20px"
								@change="getMonthData()"
						>
							<el-option
									v-for="item in monthList"
									:key="item.value"
									:label="item.label"
									:value="item.value"
							></el-option>
						</el-select>
					</td>
				</tr>
			</table>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="monthCheckVisible = false">{{$t('getapi[2054]')}}</el-button>
				<el-button size="small" type="primary" @click="confirmMonthCheck(0)">{{$t('getapi[2051]')}}</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import Common from '@/components/Common';
import Array from '@/components/Array';
import CommonHeader from '@/components/CommonHeader';
export default {
	name:'3_salinvoiceshipnoteimport',
    computed: {
        tableHeight(){
            return this.$windowSize.tableHeight-170
        }
    },
	data() {
		return {
            fileList: [],
			fileListOutSys: [],
            returnArray:[],
			returnArrayOutSys:[],
			itevisible:false,
			tabIndex:'0',
			ids: '',
			showloading: '',
			DbTbNames: '', //表名
			datajson: [],
			datajsonremark: [],
			datajsonoutsys: [],
			loading: false, // 主表加载状态
            excelURL:'',
			uploadurl: '',
			uploadurlplan:'',
			uploadurlremark: '',
			uploadurloutsys: '',
			drolist: [],
			drolistliu: [],
			drosele: 0,
			droseleliu: 0,
			total1: 0,
			btn:{
				//添加
				Add:true,
				//移除
				Remove:false,
				//导入
				Import:true
			},
            scrollTop:0,
			monthCheckVisible: false,//月结弹窗
			
            monthList: [
                {
                    value: 1,
                    label: 1,
                },
                {
                    value: 2,
                    label: 2,
                },
                {
                    value: 3,
                    label: 3,
                },
                {
                    value: 4,
                    label: 4,
                },
                {
                    value: 5,
                    label: 5,
                },
                {
                    value: 6,
                    label: 6,
                },
                {
                    value: 7,
                    label: 7,
                },
                {
                    value: 8,
                    label: 8,
                },
                {
                    value: 9,
                    label: 9,
                },
                {
                    value: 10,
                    label: 10,
                },
                {
                    value: 11,
                    label: 11,
                },
                {
                    value: 12,
                    label: 12,
                },
            ],
			month:'',
            yearL:'',
            year:'',
			yearList: [],
		};
	},
	create() {},
	beforeMount() {
		console.log('beforeMount');
		let that = this;
		that.userData = sessionStorage.getItem('userData');
		let token = JSON.parse(that.userData).token;
		//更新系统内数据
		that.uploadurl = Common.Url + '/Sal/Account/SalInvoiceShipNoteImportUpFile?token=' + token;
		// 上传系统外数据
		that.uploadurloutsys = Common.Url + '/Sal/Account/SalInvoiceShipNoteOutSysImportUpFile?token=' + token;
	},
    watch: {
        datajson: function () {
            let that = this
            that.$nextTick(function () {
                that.$processdata.initForm(0)
            })
        },
    },
    activated () {
        let that = this
        setTimeout(() => {
            that.$refs.CloseSoTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop = res.target.scrollTop
            },false)
        }, 5000);
        // 路由跳转回来滚动到离开时的位置
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.CloseSoTable.bodyWrapper.scrollTop =this.scrollTop;
            }, 13)
        })
    },
	mounted() {
		let that = this;
		let thisyear = new Date().getFullYear();
        for (let i = 0; i < 5; i++) {
            let obj = {
                value: thisyear - i,
                label: thisyear - i,
            };
            that.yearList.push(obj);
        }
        that.year = thisyear;
		this.authority();
	},
	methods: {
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[4025]"),this.$t("getapi[6589]"));
        },
        authority(){
            let that = this
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
            that.$refs.SetBtn.SetButtonEnable('');
        },
		// SO选择弹框
		showitems(type) {
			let that =this;
			that.itevisible = true;
			let param = {
				Code: type
			}
			that.tabIndex=type;
            this.$refs.input.clearInput(this.itevisible, param);
		},
		deleteAll(){
			let that = this;
			let selectRecords = this.$refs.CloseSoTable.getCheckboxRecords();
			for(let i=selectRecords.length-1;i>=0;i--){
				let line = this.$refs.CloseSoTable.getRowIndex(selectRecords[i]);
				that.datajson.splice(line, 1);
			}
		},
		deleteAllOut(){
			let that = this;
			let selectRecords = this.$refs.CloseTableOutSys.getCheckboxRecords();
			for(let i=selectRecords.length-1;i>=0;i--){
				let line = this.$refs.CloseTableOutSys.getRowIndex(selectRecords[i]);
				that.datajsonoutsys.splice(line, 1);
			}
		},
		//校验1
		check(){
			let that = this;
			if (that.datajson.length<= 0)
            {
                this.$message.warning(that.$t('getapi[4435]'));//"请首先添加要执行关闭的SO工单号。"
                return;
			}
			let count = 0;
			for (let i=0;i<that.datajson.length;i++)
			{
				
				if (that.datajson[i].State == null || (that.datajson[i].State != "未校验" && that.datajson[i].State != "可关闭" && that.datajson[i].State != "不可关闭"))
				{
					count = 1;
					break;
				}
			}
			if (count > 0)
			{
				this.$message.warning(that.$t('getapi[4438]'));//列表中有不存在或非开工状态的SO单，请删除或修改。
				return;
			}
			
			let parm = []
			for( let i=0;i<that.datajson.length;i++){
			parm = [...parm, {
				so_code: that.datajson[i].so_code,
				part_code: that.datajson[i].part_code,
				part_version: that.datajson[i].part_version,
				State: that.datajson[i].State,
				item_code: that.datajson[i].item_code,
				remark: that.datajson[i].remark,
			}]
			}
			that.$http.urlpost('/Pro/SO/CloseSoItemCheck', parm, function(res) {
			if (res.Success == 1) {
				that.datajson = res.DataContent;				
			}
			});
		},
		//执行关闭
		update(){
            let that = this;
            that.loading = true;
            let data ={
				Lists:that.datajson,
                LangType: that.$processdata.getLang()
			};
            that.$http.urlpost('/Sal/Account/UpdateSalInvoiceShipNote', data, function(res) {
            if (res.Success == 1) {
            that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
            }
            that.loading = false;
            });

		},
		update2(){
			let that = this;
			if(that.datajsonoutsys.length>0){
				that.$http.urlpost('/Pro/SO/PlanSoExecute', that.datajsonoutsys, function(res) {
				if (res.Success == 1) {
				//that.datajson = res.DataContent;
				that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
				}
				});
			}

		},
		download(){
			let param={
					url:'/Pro/SO/CloseSOTemplate'
				}
				Array.methods.DownLoadTemp(param);
		},
		download2(){
			let param={
					url:'/Pro/SO/ModifySODateTemplate'
				}
				Array.methods.DownLoadTemp(param);
		},
		monthCheck(val) {
            let that = this
			that.monthCheckVisible = true
        },
		getMonthData(selectedMonths){
			console.log('选中的月份:', selectedMonths); // 例如 ['01', '03']
		},
		confirmMonthCheck(val){
            let that = this
            if (that.month == '' || that.year == '') {
                that.$message.warning(that.$t('getapi[8783]'))//'年月不能为空'
                return
            }
            let parm = {
                TYear: that.year,
                Month: that.month
            }
            that.$http.urlpost('/Sal/Account/SalInvoiceShipNoteImportUpFileTemplate', parm, function (res) {
                if (res.Success == 1) {
                    that.monthCheckVisible = false
                    window.open(res.DataContent.URL)
                }
            });
		},
		downloadTemplate(val){
            let that = this
            that.$http.urlpost('/Sal/Account/SalInvoiceShipNoteImportOutSysTemplate', null, function (res) {
                if (res.Success == 1) {
                    that.monthCheckVisible = false
                    window.open(res.DataContent.URL)
                }
            });
		},
		//删除行
		delline(e) {
			console.log(e);
			let line = e.$rowIndex;
			if (line >= 0) {
				this.datajson.splice(line, 1);
			} else {
				this.$message.error(this.$t('getapi[8710]'));//'移除失败'
			}
		},
		dellines(e) {
			let line = e.$rowIndex;
			if (line >= 0) {
				this.datajsonremark.splice(line, 1);
			} else {
				this.$message.error(this.$t('getapi[8710]'));//'移除失败'
			}
		},
		dellineliu(e) {
			let line = e.$rowIndex;
			if (line >= 0) {
				this.datajsonoutsys.splice(line, 1);
			} else {
				this.$message.error(this.$t('getapi[8710]'));//'移除失败'
			}
		},

		handleSelectionChange(val) {
			let that = this;
			that.selectIDData = '';
			for (let i = 0; i < val.length; i++) {
				that.selectIDData += val[i].Exclusively_Id + ',';
			}
			console.log(that.selectIDData);
		},
		//工艺工时更新字段下拉框
		getDropList() {
			let that = this;
			that.$http.urlpost('Eng/Routings/RWHoursDropList', {}, res => {
				console.log(res);
				if (res.Success == 1) {
					that.drolist = res.DataContent;
					that.total1 = res.DataContent.length;
				}
			});
		},
		//流转下拉
		getDropLists() {
			let that = this;
			that.$http.urlpost('Eng/Routings/RoutMoveDropList', {}, res => {
				console.log(res);
				if (res.Success == 1) {
					that.drolistliu = res.DataContent;
				}
			});
		},

		handleChange(file, fileList) {
			let that = this;
			that.loading = true;
			console.log(file);
			if (file.response) {
				let response = file.response.Success;
				if (response == 0) {
					that.$message.error(file.response.Msg);
				} else {
					that.datajson = file.response.DataContent.Lists;
                    that.returnArray = file.response.DataContent.TbHeader;
				}
				that.loading = false;
			}
		},
		handleSuccess(res, file, fileList) {
			let that = this;
			let response = res.Success;
			if (response == 0) {
				that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
			} else {				
				that.datajson = res.DataContent.Lists;                    
				that.returnArray = res.DataContent.TbHeader; 
			}
			that.fileList=[];
		},
		handleError(err, file, fileList) {
			let that = this;
			that.$message.error(that.$t('getapi[8585]')+':' + err);//上传失败
		},
		handleChangeremark(file, fileList) {
			let that = this;
			console.log(file);
			if (file.response) {
				let response = file.response.Success;
				if (response == 0) {
					that.$message.error(file.response.Msg);
				} else {
					that.datajsonremark = file.response.DataContent;
				}
			}
		},
		handleSuccessremark(res, file, fileList) {
			let that = this;
			console.log(res);
			let response = res.Success;
			if (response == 0) {
				that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
			} else {
				that.datajsonremark = res.DataContent;
			}
		},
		handleErrorremark(err, file, fileList) {
			let that = this;
			that.$message.error(that.$t('getapi[8585]')+':' + err);//上传失败
		},
		handleChangeoutsys(file, fileList) {
			let that = this;
			console.log(file);
			if (file.response) {
				let response = file.response.Success;
				if (response == 0) {
					that.$message.error(file.response.Msg);
				} else {
					that.datajsonoutsys = file.response.DataContent.Lists;
					that.returnArrayOutSys = file.response.DataContent.TbHeader;
				}
			}
		},
		handleSuccessoutsys(res, file, fileList) {
			let that = this;
			console.log(res);
			let response = res.Success;
			if (response == 0) {
				that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
			} else {
				that.datajsonoutsys = res.DataContent.Lists;
				that.returnArrayOutSys = res.DataContent.TbHeader; 
			}
			that.fileListOutSys=[];
			
		},
		handleRemove(file, fileList) {
			console.log(file, fileList);
		},
		handlePreview(file) {
			console.log("handlePreview"+file);
		},
		// 保存数据
		okbtn() {
			let that = this;
			that.loading = true;
			let parm = {
				SaveType: that.drosele,
                LangType: that.$processdata.getLang(),
				List: []
			};
			parm.List = that.datajson;
			console.log(JSON.stringify(parm));
			that.$http.urlpost('Eng/Routings/RWHoursSave', parm, function(res) {
				if (res.Success == 1) {
					that.$message.success(that.$t('getapi[818]'));
				}
				that.loading = false;
			});
		},
		// 保存备注数据
		okbtns() {
			let that = this;
			that.loading = true;
			let parm = that.datajsonremark;
			console.log(JSON.stringify(parm));
			that.$http.urlpost('Eng/Routings/RoutRemarkSave', parm, function(res) {
				if (res.Success == 1) {
					that.$message.success(that.$t('getapi[818]'));
				}
				that.loading = false;
			});
		},
		// 
		okbtnOutSys() {
			let that = this;
			that.loading = true;
			let parm ={
				Lists:that.datajsonoutsys,
                LangType: that.$processdata.getLang()
			};
			that.$http.urlpost('Sal/Account/UpdateSalInvoiceShipNoteOutSys', parm, function(res) {
			if (res.Success == 1) {
				that.$message.success(that.$t('getapi[818]'));
			}
				that.loading = false;
			});			
		}
	}
};
</script>

<style lang="scss" scoped>
span.label-fade-enter {
	font-size: medium;
	margin-right: 20px;
}
</style>
<style>
  .el-message-box {
    width: 600px;
  }
</style>
